import { Expression } from './Expression.js';
export class LetExpression extends Expression {
    constructor(variableDeclarationExpressions, inContextDef) {
        super();
        this.variableDeclarationExpressions = variableDeclarationExpressions;
        this.inContextDef = inContextDef;
    }
    evaluate(visitor, localVariables) {
        const variableExpression = this.variableDeclarationExpressions[0];
        const variables = { [variableExpression.getVariableName()]: variableExpression.evaluate(visitor) };
        return this.inContextDef.evaluate(visitor, Object.assign(Object.assign({}, localVariables), variables));
    }
}
//# sourceMappingURL=LetExpression.js.map